import React, {useMemo, useState} from "react";
import {useDebounce} from "react-use";
import {useAPI} from "../../config/API";
import {PictureOutlined} from "@ant-design/icons";
import {Empty, Select} from "antd";
import LoadingSpinner from "../LoadingSpinner";

const SearchBrandsInput = (props) => {

    const [search, setSearch] = useState('');
    const [allBrands, setAllBrands] = useState([])
    const [searchInput, setSearchInput] = useState(props.value?.name || '');
    const [debounceLoading, setDebounceLoading] = useState(false);
    const [debounceInput, setDebounceInput] = useState('');

    const [isSearchReady, cancel] = useDebounce(
        () => {
            setDebounceInput(search);
        },
        650, [search]
    );

    const {
        data,
        isFetching,
        error,
        refetch
    } = useAPI(['searchBrands', {search: debounceInput, platform: props.platformBrands}], {
        enabled: debounceInput?.length > 0 && search?.length > 0 && debounceInput?.length === search?.length,
        keepPreviousData: true,
        onSuccess: (brands) => {
            let uniqBrands = brands;
            if (TB.find(brands, brand => !!brand.brandId)) {
                uniqBrands = TB.uniqBy([...brands || [],...allBrands], 'brandId')
            }
            setAllBrands(uniqBrands);
        }
    });

    const [isLoadingReady, cancelLoading] = useDebounce(
        () => {
            setDebounceLoading(isFetching);
        },
        400, [isFetching]
    );

    const searchOptions = useMemo(() => {
        if (!search?.length) return [];

        let options = TB.uniqBy(data || [], brand => brand.id || brand.brandId || brand.domain);
        if (props.disabledOptions?.length > 0) {
            options = TB.filter(options,option => !props.disabledOptions?.includes(option.id || option.brandId || option.domain));
        }
        return TB.map(TB.filter(options, item => !!item.name), option => ({
            value: option.id || option.brandId || option.domain,
            display: option.name,
            brand: option,
            label: (
                <div className="flex flex-row items-center justify-between">
                    <div className="flex flex-row items-center gap-2">
                        {option.icon ? <img className="h-8 min-w-8 max-w-64" src={option.icon} /> : (
                            <PictureOutlined className="h-8 min-w-8" style={{fontSize: 23}} />
                        )}
                        <p className="text-sm">{option.name || option.domain}</p>
                    </div>
                    {option.name && option.domain && (
                        <p className="text-xxs text-info text-right whitespace-nowrap">
                            {option.domain}
                        </p>
                    )}
                </div>
            ),
        }));
    }, [search,data,debounceLoading, isFetching]);


    if (props.value?.id || props.value?.name) {
        return (
            <div className="flex flex-row items-center justify-between">
                <div className="flex flex-col flex-grow gap-4">
                    <div className="flex flex-row items-start gap-6">
                        <div className="basis-1/5 self-center">
                            {(props.value.logo || props.value.icon) ? <img className="w-full max-w-full" src={props.value.logo || props.value.icon}
                                                     alt={props.value.name}/> : (
                                <PictureOutlined className="w-full max-w-full" style={{fontSize: 56}}/>
                            )}
                        </div>

                        <div className="flex flex-row items-stretch flex-grow justify-start">
                            <div className="flex flex-col gap-1">
                                <p className="text-lg">{props.value.name || props.value.domain}</p>
                                {props.value.name && props.value.domain && (
                                    <p className="text-sm text-info whitespace-nowrap">
                                        {props.value.domain}
                                    </p>
                                )}
                            </div>
                            {props.onClear && !props.disabled && (
                                <div className="self-center">
                                    <div onClick={e => {
                                        if (!props.disabled) {
                                            props.onClear()
                                        }
                                    }} className="ml-3 clickable fa fa-times-circle text-danger self-start"/>
                                </div>
                            )}
                        </div>


                    </div>

                    {/*{props.value.description && (*/}
                    {/*    <p className="text-xs">*/}
                    {/*        {props.value.description}*/}
                    {/*    </p>*/}
                    {/*)}*/}

                </div>
            </div>
        )
    }
    if (props.value?.brandId) {
        return (
            <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row items-center gap-4">
                    {props.value.icon ?
                        <img className="h-12 min-w-12" src={props.value.icon} alt={props.value.name}/> : (
                            <PictureOutlined className="h-12 min-w-12" style={{fontSize: 56}}/>
                        )}
                    <div className="flex flex-col gap-1">
                        <p className="text-base">{props.value.name || props.value.domain}</p>
                        {props.value.name && props.value.domain && (
                            <p className="text-sm text-info text-right whitespace-nowrap">
                                {props.value.domain}
                            </p>
                        )}
                    </div>
                    {props.onClear && (
                        <div>
                            <div onClick={e => {
                                props.onClear()
                            }} className="clickable fa fa-times-circle text-danger self-start"></div>
                        </div>
                    )}
                </div>

            </div>
        )
    }

    return (
        <Select
            style={{width: '100%'}}
            name="search_brands"
            placeholder={props.placeholder || "Search by Name or Domain"}
            maxLength={255}
            showSearch
            disabled={props.isDisabled}
            showArrow={!props.isDisabled}
            filterOption={(input, option) =>
                TB.trim((option?.display ?? '')?.toLowerCase()).includes(TB.trim(input?.toLowerCase())) ||
                TB.trim(input?.toLowerCase()).includes(TB.trim((option?.display ?? '')?.toLowerCase()))}
            filterSort={(optionA, optionB) =>
                (optionA?.display ?? '').toLowerCase().localeCompare((optionB?.display ?? '').toLowerCase())
            }
            options={searchOptions}
            optionFilterProp="children"
            optionLabelProp={searchOptions?.length > 0 ? 'display' : undefined}
            defaultActiveFirstOption={false}
            onSelect={async (brandId, option) => {

                console.log('brand', option)
                await props.onChange({...option.brand});

                if (props.shouldReset) {
                    await setSearch('')
                    console.log('reset', search)
                    console.log('reset', debounceInput)

                }
            }}
            autoClearSearchValue={props.autoClearSearchValue}
            value={props.value || undefined}
            searchValue={search}
            onSearch={setSearch}
            notFoundContent={(isFetching || debounceLoading) ? (
                <div className="flex flex-col items-center justify-center my-8 h-20 gap-2">
                    <LoadingSpinner size={'lg'} />

                    <p className="text-sm opacity-6 text-center">Loading results...</p>
                </div>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={search?.length ? "No brands found." : 'Start typing to search'}/>
            )}
            loading={isFetching || debounceLoading}
        />
    )
}
export default SearchBrandsInput;